<template lang="pug">
.faq-spoiler(:class="{'type-opened': isOpened}")
  .faq-spoiler__title(@click="toggleSpoiler")
    slot(name="faq-spoiler_title")
    .faq-spoiler__marker
      .faq-spoiler__marker-symbol
  .faq-spoiler__content.text
    slot
</template>

<script>
export default {
  name: "FaqSpoilerItem",

  data: function() {
    return {
      isOpened: false,
    };
  },

  methods: {
    toggleSpoiler: function() {
      return (this.isOpened = !this.isOpened);
    },
  },
};
</script>

<style lang="scss">
@import "../style/faq_spoiler_item.scss";
</style>
